import { OperationResult } from '@vp/common/core/OperationResult';

export abstract class AvatarManagerPort {
  abstract remove(profileId: string, avatarId: string, controller?: AbortController): Promise<boolean>;
  abstract upload(profileId: string, avatarFile: File, controller?: AbortController): Promise<boolean>;
  abstract makeLive(controller?: AbortController): Promise<OperationResult>;
  abstract makeStatic(controller?: AbortController): Promise<OperationResult>;
  abstract hasProfileImageAnimationAttempts(): boolean;
}
